import { createContext } from 'react';

export const ComboboxMultipleContext = createContext<{
  value: string[];
  onSelect: (val: string) => void;
  color?: string;
} | null>(null);
